import React from 'react';
import {
  Box, Button,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Popover, Stack,
  Typography
} from "@mui/material";
import {useAuth} from "src/PWM/hooks/use-auth";
import {PWMThemeSelector} from "../settings/PWMThemeSelector";
import PWMUserAvatar from "../settings/PWMUserAvatar";


const PWMAccountPopover: React.FC<IPWMAccountPopoverProps> = (props) => {
  const {anchorEl, onClose, open, ...other} = props;
  const {account, logout} = useAuth();

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'center',
        vertical: 'bottom'
      }}
      keepMounted={true}
      disableScrollLock={true}
      onClose={onClose}
      open={!!open}
      PaperProps={{sx: {width: 385}}}
      {...other}
    >
      <Box
        sx={{
          alignItems: 'center',
          p: 2
        }}
      >
        <Stack>
          <Box sx={{display: 'flex'}}>
            <ListItemIcon>
              <PWMUserAvatar/>
            </ListItemIcon>
            <MenuItem sx={{pt: 0, mt: 0}}>
              <ListItemText sx={{textAlign: 'right'}}>
                <Typography variant="body1">
                  {account?.name}
                </Typography>
              </ListItemText>
            </MenuItem>
          </Box>
          <MenuItem component="a">
            <ListItemIcon sx={{m: 0, p: 0}}>
              <Button onClick={logout} variant="text">Logout</Button>
            </ListItemIcon>
            <ListItemText sx={{textAlign: 'right'}}>
              {/*<PWMLink
                href="/settings/profile" todo implement this page
              >*/}
               <Typography
                  color="textSecondary"
                  variant="body2"
                >
                  {account?.username}
                </Typography>
              {/*</PWMLink>*/}
            </ListItemText>
          </MenuItem>
        </Stack>
      </Box>
      <Divider/>
      <Stack
        sx={{p: 2, m: 0}}
      >
        <PWMThemeSelector/>
      </Stack>
    </Popover>
  )
};

export default PWMAccountPopover;

interface IPWMAccountPopoverProps {
  children?: React.ReactNode;
  anchorEl: null | Element;
  onClose?: () => void;
  open?: boolean;
}